import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/404.css';

const NotFound = () => {
  const [clicks, setClicks] = useState(0);
  const [showRevenge, setShowRevenge] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const navigate = useNavigate();

  const handleClick = () => {
    if (clicks >= 3) {
      setShowRevenge(true);
    } else {
      setClicks(clicks + 1);
    }
  };

  const handleRevenge = () => {
    setShowVideo(true);
    setTimeout(() => {
      let count = 3;
      setCountdown(count);
      const interval = setInterval(() => {
        count -= 1;
        setCountdown(count);
        if (count === 0) {
          clearInterval(interval);
          navigate('/');
        }
      }, 1000);
    }, 4000); // Delay before countdown starts
  };

  return (
    <div className='error-page'>
      {!showVideo ? (
        <>
          <div className={`error-404 face-stage-${clicks}`}>
            <span>4</span>
            <div className='face-container'>
              {/* <img src={`/faces/face-${clicks}.png`} alt="Your Face" className="face-img" /> */}
              {clicks > 0 && <div className='speech-bubble'>Oops!</div>}
            </div>
            <span>4</span>
          </div>

          {!showRevenge ? (
            <button
              className='move-button'
              onClick={handleClick}
              style={{
                top: `${Math.random() * 50 + 25}%`,
                left: `${Math.random() * 50 + 25}%`,
              }}
            >
              Back to Home
            </button>
          ) : (
            <button className='revenge-button' onClick={handleRevenge}>
              Take Revenge
            </button>
          )}
        </>
      ) : (
        <div className='video-container'>
          <video autoPlay muted>
            <source src='/videos/missile1.mp4' type='video/mp4' />
          </video>
          <div className='explosion'>💥💥💥</div>
          {countdown !== null && (
            <div className='countdown'>Back to Home in {countdown}...</div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotFound;
